import { PageLayout } from '@plm-core/utils'
import UsersSearchList from 'users/search/UsersSearchList'

const UsersSearchPage = () => {
  return (
    <PageLayout>
      <UsersSearchList />
    </PageLayout>
  )
}

export default UsersSearchPage
